import { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import {
//   FlexBetween,
//   FlexJustifyCenter,
//   HubLengthMessage
// } from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FlexJustifyCenter, HubLengthMessage } from '../../styles/stylesStyled';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import {
  AnimatedDashboard,
  AnimatedTab,
  Button,
  SidebarModal
} from '../../components';
import { formatUSD, formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { InvoiceHeader, Invoices } from './OrdersStyled';
import {
  Invoice,
  MyOrderListModel,
  OrderItem,
  Payment
} from '../Marketplace/Maeketplace.types';
import { useAppSelector } from '../../app/hooks';
import { useParams } from 'react-router-dom';
import { getOrders } from '../../slices/orders-slice';
import { useDispatch } from 'react-redux';
import { InvoicesTicket } from './InvoicesTicket';

export const OrderInvoices = () => {
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const { id } = useParams<{ id: string }>();
  const [payments, setPayments] = useState<Payment[]>();

  const { orders } = useAppSelector((state) => state.orders);
  const filteredOrder = orders.find((order) => order.id === Number(id));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  return (
    <>
      <AnimatedDashboard zoom>
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <div style={{ minWidth: 800 }}>
            <InvoiceHeader>
              <div style={{ width: '5%' }}>Id</div>
              <div style={{ width: '20%' }}>Number</div>
              <div style={{ width: '10%' }}>Price</div>
              <div style={{ width: '15%' }}>Amount Pending</div>
              <div style={{ width: '15%' }}>Amount Paid</div>
              <div style={{ width: '15%' }}>Date Created</div>
              <div style={{ width: '15%' }}>Date Paid</div>

              <div style={{ width: '15%' }}>Status</div>
            </InvoiceHeader>
            {filteredOrder?.invoices?.map((inv: Invoice, i: number) => {
              return (
                <AnimatedItem key={i} index={i}>
                  <Invoices>
                    <div style={{ width: '5%' }}>{inv.id}</div>
                    <div style={{ width: '20%' }}>{inv.invoiceNumber}</div>
                    <div style={{ width: '10%' }}>
                      {formatUSDNoDecimals(inv.amount)}
                    </div>
                    <div style={{ width: '15%' }}>
                      {' '}
                      {formatUSDNoDecimals(inv.amountPending)}
                    </div>
                    <div style={{ width: '15%' }}>
                      {formatUSDNoDecimals(inv.amountPaid)}
                    </div>
                    <div style={{ width: '15%' }}>
                      {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                    </div>
                    <div style={{ width: '15%' }}>
                      {inv?.datePaid &&
                        moment.utc(inv?.datePaid).format('DD/MM/YY')}
                    </div>

                    <div style={{ width: '15%' }}>{inv?.status}</div>
                  </Invoices>
                </AnimatedItem>
              );
            })}
          </div>
        </div>
      </AnimatedDashboard>
      <SidebarModal
        isOpen={isInvoiceModalOpen}
        setOpen={setIsInvoiceModalOpen}
        title={'Invoices'}
        sidebarWidth={'650px'}>
        <InvoicesTicket payments={payments} />
      </SidebarModal>
    </>
  );
};
